import { useContext } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";

const VideoControlsBar = () => {
  const rootStore = useContext(RootStoreContext);
  const { VideoWidgetCommandEvent } = rootStore.tenantStore;

  return (
    <>
      <div className="videoControls">
        <button
          className="videoControlsButton mr-2"
          onClick={() => VideoWidgetCommandEvent("stop")}
        >
          <i className="far fa-stop"></i>
        </button>
        <button
          className="videoControlsButton mr-2"
          onClick={() => VideoWidgetCommandEvent("play")}
        >
          <i className="far fa-play-circle"></i>
        </button>
        <button
          className="videoControlsButton mr-2"
          onClick={() => VideoWidgetCommandEvent("pause")}
        >
          <i className="far fa-pause-circle"></i>
        </button>
        {/* <button
          className="videoControlsButton mr-2"
          onClick={() => VideoWidgetCommandEvent("mute")}
        >
          <i className="fas fa-volume-mute"></i>
        </button>
        <button
          className="videoControlsButton"
          onClick={() => VideoWidgetCommandEvent("unmute")}
        >
          <i className="fas fa-volume"></i>
        </button> */}
      </div>
    </>
  );
};

export default VideoControlsBar;
